// extracted by mini-css-extract-plugin
export default {"notFound":"notFound-notFound__582vM","fourohfour":"notFound-fourohfour__H10SG","routeNotFound":"notFound-routeNotFound__ITtCO"};